import TopHierarchySelection from '../../../../dataViews/NextTree/plugins/TopHierarchySelection';

export default {
  makeTreePlugin: canSelectNode =>
    new TopHierarchySelection({ nodeIsSelectable: canSelectNode }),
};
